import React from 'react';
import api from '../api';
import { Eye, EyeOff } from 'lucide-react';

const ChangePassword = ({ onSuccess }) => {
    const [password, setPassword] = React.useState('');
    const [confirm, setConfirm] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [error, setError] = React.useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirm) {
            setError('Las contraseñas no coinciden');
            return;
        }
        try {
            await api.post('users/change_password/', { password });
            onSuccess();
        } catch (err) {
            setError('Error al cambiar contraseña');
        }
    };

    return (
        <div className="login-page">
            <div className="login-overlay"></div>
            <div className="login-content-container animate-fade-in">
                <div className="login-card glassmorphism p-5 shadow-2xl">
                    <div className="text-center mb-4">
                        <h2 className="section-title">Cambiar Contraseña</h2>
                        <p className="text-muted">Por seguridad, debes cambiar tu contraseña inicial.</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="form-floating mb-3 position-relative">
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="form-control pe-5" 
                                placeholder="Nueva Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <label>Nueva Contraseña</label>
                            <button
                                type="button"
                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent text-muted me-2"
                                style={{ zIndex: 10 }}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                        <div className="form-floating mb-4 position-relative">
                            <input 
                                type={showConfirmPassword ? "text" : "password"} 
                                className="form-control pe-5" 
                                placeholder="Confirmar Contraseña"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                required
                            />
                            <label>Confirmar Contraseña</label>
                            <button
                                type="button"
                                className="btn position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent text-muted me-2"
                                style={{ zIndex: 10 }}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            >
                                {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                        {error && <div className="alert alert-danger p-2 small">{error}</div>}
                        <button type="submit" className="btn btn-primary-gradient w-100 py-3 font-bold">ACTUALIZAR Y ENTRAR</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
